import { Component, OnInit } from '@angular/core';
import { HammaddeService } from '../_services/hammadde.service';
import { AddhammaddeComponent } from './addhammadde/addhammadde.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-hammadde',
  templateUrl: './hammadde.component.html',
  styleUrls: ['./hammadde.component.css']
})
export class HammaddeComponent implements OnInit {
  hammeddeler:any[]=[];
  filteredhammeddeler:any[]=[];
  page=1;
  arama:any;
  constructor(
    private hammaddeService:HammaddeService,
    private modal:NgbModal,
    private toastr: ToastrService) { }
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  ngOnInit() {
    this.getHammaddeler(this.page);
  }


  getHammaddeler(page:number){
    this.blockUIChangelog.start('Loading..');
    this.hammaddeService.getHammaddeler(page).subscribe(res=>{
      this.hammeddeler=res;
      this.filteredhammeddeler=res;
      this.blockUIChangelog.stop();
    },err=>{
      this.blockUIChangelog.stop();
    });
  }

  openSaveModal(){
    const modalref=  this.modal.open(AddhammaddeComponent, { size: 'xl' });
   
    modalref.result.then((result)=>{
     this.getHammaddeler(this.page);
    });
    }

    openEditModal(data:any){
      const modalref=  this.modal.open(AddhammaddeComponent, { size: 'xl' });
      modalref.componentInstance.hammadde=data;
      modalref.result.then((result)=>{
       this.getHammaddeler( this.page);
      });
      }


    delete(id){
        this.hammaddeService.deleteHammadde(id).subscribe(res=>{
          this.getHammaddeler(this.page);
          this.toastr.success('', 'Kayıt silindi');
        });
    }

    prevPage(){
      if(this.page>1){
        this.page--;
        if(this.arama){
         this.hammaddeService.search(this.arama,this.page).subscribe(res=>{
          console.log(res);
          this.filteredhammeddeler=res;
        });
      }
      else{
      this.getHammaddeler(this.page);
      }
      }
     
    }
    nextPage(){
      console.log(this.arama);
      this.page++;
      if(this.arama){
         this.hammaddeService.search(this.arama,this.page).subscribe(res=>{
          this.filteredhammeddeler=res;
        });
      }
      else{
      this.getHammaddeler(this.page);
      }
  
    }

    search(data:any){
     
        if(data.target.value.length<3){
          this.filteredhammeddeler=this.hammeddeler;
          this.arama="";
        }
        else{
          this.arama=data.target.value;

        this.hammaddeService.search(data.target.value,this.page).subscribe(res=>{
          console.log(res);
          this.filteredhammeddeler=res;
        });
        }
    }
}
